<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import {ElectronicConsent} from '../services/Store' 
    import { onMount} from "svelte";
    const dispatch = createEventDispatcher();
    export let disabled: boolean = true;
    let complete: boolean = false;
    let navigationAllowed: false;
  
    const completeElectronicConsent = () => {
        if ((navigationAllowed && !complete)) {           
            $ElectronicConsent = 'true';
            completeElectronicConsentAndContinueToNextPage();
        }
    }
    onMount(() => {
       completeElectronicConsentAndContinueToNextPage();
    });
  
  function completeElectronicConsentAndContinueToNextPage() {
        if ($ElectronicConsent === 'true'){
            dispatch("electronicConsentChanged");
            complete = true;
        }
    }

</script>

<div class="electronic-consent card">
    <h2>Electronic Consent</h2>

    <div class="text-section">
        <input type="checkbox" bind:checked={navigationAllowed}/>
        I consent to doing electronic business with Protective Life Insurance Company.  
    </div>
    <div class="action-button-container">    
        <button id="continueButton" class="pl-cta-primary"  on:click={completeElectronicConsent}   disabled={!navigationAllowed}>Continue</button>
    </div>
</div>

<style lang="scss">
  @use "../../component_scss_library/layout" as layout;
  @use "../../component_scss_library/buttons" as buttons;
</style>
